import React, {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Typography from 'brandComponents/Typography';

import {OrderDetailsPayment} from './../index';
import {IOrderDetailsPaymentsProps} from './IOrderDetailsPayments';
import messages from './messages';

const OrderDetailsPayments = ({classNames, paymentInstruments, currency}: IOrderDetailsPaymentsProps) => {
	const intl = useIntl();
	const [payments, setPayments] = useState([]);

	useEffect(() => {
		const tempPayments = [];

		paymentInstruments.forEach((paymentInstrument) => {
			tempPayments.push(<OrderDetailsPayment paymentInstrument={paymentInstrument} currency={currency} />);
		});

		setPayments(tempPayments);
	}, [paymentInstruments]);

	return (
		<div className={cn(classNames, 'order-details__payments')}>
			<Typography variant="h6">{intl.formatMessage(messages.label)}</Typography>
			{payments}
		</div>
	);
};

export default OrderDetailsPayments;
